import "primevue/resources/themes/bootstrap4-light-blue/theme.css"
import 'jquery/dist/jquery'
import 'bootstrap/dist/js/bootstrap.js';
import 'primeicons/primeicons.css'  
import './styles/app.scss';

import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'


import axios from 'axios'
import VueAxios from 'vue-axios'
import PrimeVue from 'primevue/config';
import DynamicDialog from 'primevue/dynamicdialog';
import DialogService from 'primevue/dialogservice';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Chart from 'primevue/chart';
import 'asdecode-datatable/theme/css/asdecode-datatable-bs4.css';
import AsdecodeTable from 'asdecode-datatable/src/components/AsdecodeTable.vue';
import AppTemplate from './layouts/AppTemplate.vue'

//parametres cors et la base url des requetes dans la spa
axios.defaults.withCredentials = true
axios.defaults.withXSRFToken = true;
axios.defaults.baseURL = store.getters.apiUrl

//si l'utilisateur s'est déjà connecté
const mysession = window.localStorage.getItem("lebottin241_superviseur")

if (mysession !== null) {
  const userDatas = JSON.parse(mysession);
  store.commit('setAuthenticated', userDatas);
  axios.defaults.headers.common = {
    'Authorization': 'Bearer ' + userDatas.token
  }
}


const app = createApp(App);
app.use(VueAxios, axios)
app.provide('axios', axios)
app.use(PrimeVue)
app.use(store)
app.use(router)
app.use(DialogService)
app.use(ToastService)
app.component('AsdecodeTable', AsdecodeTable);
app.component('ChartJs', Chart);
app.component('DynamicDialog', DynamicDialog);
app.component('ShowToast', Toast);
app.component('AppTemplate', AppTemplate);

app.mount('#app')
